export let goodsTableLabels = [
//   {
//     label: '浏览量',
//     value: 'goodsOtherInfoDTO.visitorVolume'
//   },
  {
    label: '库存',
    value: 'goodsOtherInfoDTO.stockQuantity'
  },
  //   {
  //     label: '销量',
  //     value: 'goodsOtherInfoDTO.saleVolume'
  //   },
  {
    label: '上架时间',
    value: 'putOnSaleTime'
  },
  {
    label: '类型',
    value: 'goodsDTO.goodsData.typeName'
  },
  {
    label: '分组',
    value: 'goodsDTO.goodsData.groupName'
  },
  {
    label: '推荐值',
    value: 'goodsOtherInfoDTO.ranking'
  },
  {
    label: '商品状态',
    value: 'goods_state'
  }
]
// 已审核商品table-label
export let revirewedGoodsLabel = reviewLabel()
export function reviewLabel () {
  let revirewedGoodsLabel
  revirewedGoodsLabel = goodsTableLabels.filter(function (ele) {
    return ele.label !== '上架时间'
  })
  return revirewedGoodsLabel
}
export let pageStutesTabs = [
  {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '已通过审核',
    value: 'PUBLISHED'
  }
]
export let reviewTimeSelect = [
  {
    label: '立即上架',
    value: 'now'
  },
  {
    label: '指定上架时间',
    value: 'other'
  }
]
